import { boot } from 'quasar/wrappers'
import { Platform } from 'quasar'
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser'; // Importação adicionada

export default boot(({ router, store }) => {
	if (Platform.is.capacitor && window.self === window.top) {
		App.addListener('appUrlOpen', async (data) => {
			if (data.url.includes('/media_public/')) {
				await Browser.open({ url: data.url });
				return;
			}

			const url = new URL(data.url)

			// Correção: Usando data.url (string) em vez da variável url (objeto)
			const parts = data.url.split('token=');
			const token = parts[1];

			if (token) {
				alert('atualizou' + token)
			}

			if (url.pathname !== '/' || url.search !== '') {
				router.push({
					path: `${url.pathname === '/' ? '/home' : url.pathname}${url.search}`
				})
			}
		})

		if (Platform.is.ios) {
			App.addListener('appUrlOpen', async (event) => {
				const url = event.url;

				if (url.includes('/media_public/qrcode/')) {
					await Browser.open({ url: url });
					return;
				}
				const urlPath = url.split('.app').pop();
				if (urlPath) {
					const parts = urlPath.split('token=');
					const token = parts[1];
					if (token) {
						store.dispatch('redirect/SET_TOKEN', [token])
						router.push({
							path: `/login`
						})
					}
				}
			});
		}
	}
})